module.exports = __webpack_public_path__ + "img/bookcase.7c2d0e4b.svg";